import m from 'mithril';
import { routes } from './src/App';
import { Store } from './src/store';

const root = document.getElementById('root');
if (root) {
    // Restore session SYNCHRONOUSLY from localStorage before mounting
    const token = localStorage.getItem('auth_token');
    const userJson = localStorage.getItem('auth_user');
    if (token && userJson) {
        try {
            Store.state.user = JSON.parse(userJson);
            // Re-write cookie so it's forwarded on proxied API requests
            document.cookie = `auth=${token}; path=/; SameSite=Lax; max-age=${86400 * 7}`;
        } catch {}
    }

    // Mount router immediately — user session is already available
    m.route(root, '/', routes);

    // Load products in the background
    Store.initApp();
}

